import { WindowSize } from '@Entities/ui'
import { action, computed, observable, makeObservable } from 'mobx'
import { checkIsMobile } from '@App/helpers/check-is-mobile'
import { urlHasComponent } from '@App/helpers/url'
import RootStore from '@App/stores/root-store'

export default class UiStore {
    private _rootStore: RootStore

    private _windowSize: WindowSize

    private _onLoginPage: boolean

    private _homePageState: 'member' | 'songwriter'

    // todo move this bulk upload wizard store when it is made
    private _bulkUploadModalIsOpen: boolean

    private _showSubNavigation: boolean

    constructor(rootStore: RootStore) {
        makeObservable<
            UiStore,
            '_windowSize' | '_onLoginPage' | '_homePageState' | '_bulkUploadModalIsOpen' | '_showSubNavigation'
        >(this, {
            _windowSize: observable,
            _onLoginPage: observable,
            _homePageState: observable,
            _bulkUploadModalIsOpen: observable,
            _showSubNavigation: observable,
            setWindowSize: action,
            setOnLoginPage: action,
            setHomePageState: action,
            setBulkUploadModalIsOpen: action,
            setShowSubNavigation: action,
            isMobile: computed,
            homePageState: computed,
        })
        this._rootStore = rootStore
        this._bulkUploadModalIsOpen = true
        this._showSubNavigation = true
        this._onLoginPage = urlHasComponent('login')
    }

    get windowSize(): WindowSize {
        return this._windowSize
    }

    get onLoginPage(): boolean {
        return this._onLoginPage
    }

    get bulkUploadModalIsOpen(): boolean {
        return this._bulkUploadModalIsOpen
    }

    get homePageState() {
        const hasBoth =
            this._rootStore.songwriterSearchStore.songwriters?.totalElements > 0 &&
            this._rootStore.rightsholderSearchStore.rightsholders?.totalElements > 0
        return (
            this._homePageState ??
            (hasBoth
                ? 'member'
                : this._rootStore.songwriterSearchStore.songwriters?.totalElements > 0
                  ? 'songwriter'
                  : 'member')
        )
    }

    setWindowSize(widthData: WindowSize): void {
        this._windowSize = widthData
    }

    setOnLoginPage(onLogin: boolean): void {
        this._onLoginPage = onLogin
    }

    setBulkUploadModalIsOpen(isOpen: boolean) {
        this._bulkUploadModalIsOpen = isOpen
    }

    get showSubNavigation(): boolean {
        return this._showSubNavigation
    }

    setShowSubNavigation(show: boolean) {
        this._showSubNavigation = show
    }

    setHomePageState(state: 'member' | 'songwriter') {
        this._homePageState = state
    }

    get isMobile(): boolean {
        return this._windowSize && checkIsMobile(this._windowSize && this._windowSize.width)
    }
}
